import React from 'react';
import Items, { defaultConfigComponent as ItemsConfig } from '../Items/Items';
import { IConfigComponent } from '@ts/ui-models';

export const defaultConfigComponent: IConfigComponent = {
  ...ItemsConfig,
  componentId: 'itemsInCustody',
  entity: 'itemInCustody',
  filtersFetchData: { itemInCustody: { isAlive: true } },
};
const ItemsInCustody = props => {
  const defaultProps = {
    flavorId: 'itemInCustody',
    componentId: 'itemsInCustody',
    title: 'Items in custody',
    columnsName: ['defaultLocation', 'currentLocation', 'lastPosition'],
  };
  return <Items configComponent={defaultConfigComponent} {...props} {...defaultProps} />;
};

export default ItemsInCustody;
